import script from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=ts"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=abe7d5d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abe7d5d6"]])

export default __exports__